// レスポンスサーバ
export const RESPONSE_SERVER = {
    AWS_ELB: "awselb/2.0",
};



// WEBPACK FOOTER //
// ./src/utils/system.js